import type { ButtonHTMLAttributes } from 'react';

type Variant = 'primary' | 'secondary';

const STYLES: Record<Variant, string> = {
  primary: 'bg-blue-600 text-white hover:bg-blue-700 disabled:bg-slate-400',
  secondary:
    'border border-blue-600 bg-white text-blue-700 hover:bg-blue-50 disabled:border-slate-300 disabled:text-slate-400',
};

export function Button({
  variant = 'primary',
  className = '',
  ...props
}: ButtonHTMLAttributes<HTMLButtonElement> & { variant?: Variant }) {
  return (
    <button
      {...props}
      className={`rounded-md px-4 py-2 text-sm font-semibold transition-colors disabled:cursor-not-allowed ${STYLES[variant]} ${className}`}
    />
  );
}
